import { render, staticRenderFns } from "./RowBlockRefundFundsThroughPaymentSystem.vue?vue&type=template&id=15295f68&"
import script from "./RowBlockRefundFundsThroughPaymentSystem.vue?vue&type=script&lang=js&"
export * from "./RowBlockRefundFundsThroughPaymentSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports